export default {
  id: "id",
  username:"username",
  name: "name",
  email: "email",
  studyField: "study_field",
  phoneNumber: "phone_number ",
  createdAt:"created_at",
};
